import styled from "@emotion/styled";
import { DataGrid } from "@mui/x-data-grid";
import { Typography } from "@mui/material";

import { ReactComponent as MeterLogo } from "assets/images/svg/meter-icon.svg";
import { ReactComponent as ApplicationLogo } from "assets/images/svg/applications.svg";
import { ReactComponent as EditMeter } from "assets/images/svg/edit-meter-icon.svg";
import { ReactComponent as SolarMeter } from "assets/images/svg/solar-meter.svg";

export const StyledGrid = styled(DataGrid)`
  .MuiTablePagination-selectLabel,
  .MuiTablePagination-displayedRows {
    margin: 0;
  }
`;

export const DocumentName = styled(Typography)`
  max-width: 177px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: 2px;
  overflow: hidden;
  padding-bottom: 1px;
  line-height: 1.2;
  text-align: center;
  height: auto;
  margin-bottom: 2px;
  word-break: break-all;
`;

export const MeterIcon = styled(MeterLogo)(
  ({ theme }) => `
    fill: ${theme.palette.primary.main};
    height: 18px;
    width: 18px;
    `
);

export const ApplicationIcon = styled(ApplicationLogo)(
  ({ theme }) => `
    fill: ${theme.palette.primary.main};
    height: 18px;
    width: 18px;
    `
);

export const EditMeterIcon = styled(EditMeter)(
  ({ theme }) => `
    height: 18px;
    fill: ${theme.palette.primary.main};
    width: 18px;
  `
);

export const SolarMeterIcon = styled(SolarMeter)(
  ({ theme }) => `
    height: 18px;
    fill: ${theme.palette.primary.main};
    width: 18px;
  `
);
